// src/pages/PrivacyPolicy.js
import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="privacy-policy-page" style={styles.container}>
      <h1 style={styles.title}>Privacy Policy</h1>
      <p>
        This Privacy Policy explains how Kentech Phones ("we", "us", or "our")
        collects, uses, and discloses your personal information when you use our
        web app and services. By accessing or using our web app, you agree to the
        practices described in this Privacy Policy.
      </p>

      <h2 style={styles.subtitle}>1. Information We Collect</h2>
      <p>
        We may collect the following types of information:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}>
          <strong>Personal Information:</strong> Your name, email address, phone number,
          and mailing address when you book a repair, submit a complaint, or contact us.
        </li>
        <li style={styles.listItem}>
          <strong>Device Information:</strong> Details about your device such as the
          make, model, and repair history when you request services.
        </li>
        <li style={styles.listItem}>
          <strong>Payment Information:</strong> Payment details provided during transactions,
          processed securely by our third-party payment partners.
        </li>
        <li style={styles.listItem}>
          <strong>Usage Data:</strong> Information collected through cookies, log files,
          and analytics tools regarding your browsing and interaction with our site.
        </li>
      </ul>

      <h2 style={styles.subtitle}>2. How We Use Your Information</h2>
      <p>
        We use the collected information for various purposes, including:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}>To process and manage your repair bookings and service requests.</li>
        <li style={styles.listItem}>To communicate with you regarding your appointments, updates, and customer support.</li>
        <li style={styles.listItem}>To improve our web app, services, and marketing efforts.</li>
        <li style={styles.listItem}>To comply with legal and regulatory obligations.</li>
      </ul>

      <h2 style={styles.subtitle}>3. Information Sharing</h2>
      <p>
        We do not sell your personal information. We may share your information with:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}>
          <strong>Service Providers:</strong> Trusted third-party partners (e.g., payment
          processors, analytics providers) who assist in delivering our services.
        </li>
        <li style={styles.listItem}>
          <strong>Legal Authorities:</strong> In response to a lawful request or when required
          to protect our rights, safety, or property.
        </li>
      </ul>

      <h2 style={styles.subtitle}>4. Cookies and Tracking Technologies</h2>
      <p>
        We use cookies and similar tracking technologies to enhance your experience on our
        web app. You can manage your cookie preferences through your browser settings.
      </p>

      <h2 style={styles.subtitle}>5. Data Security</h2>
      <p>
        We implement reasonable security measures to protect your personal information
        against unauthorized access, alteration, disclosure, or destruction. However, no method
        of transmission over the internet is 100% secure.
      </p>

      <h2 style={styles.subtitle}>6. Data Retention</h2>
      <p>
        We retain your personal information only for as long as necessary to fulfill the purposes
        outlined in this Privacy Policy or as required by law.
      </p>

      <h2 style={styles.subtitle}>7. Your Rights</h2>
      <p>
        Depending on your location, you may have certain rights regarding your personal data,
        such as the right to access, correct, or delete your information. To exercise these rights,
        please contact us at the email address provided below.
      </p>

      <h2 style={styles.subtitle}>8. Children's Privacy</h2>
      <p>
        Our web app and services are not intended for individuals under the age of 13. We do not
        knowingly collect personal information from children under 13.
      </p>

      <h2 style={styles.subtitle}>9. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted on this page,
        and the updated policy will be effective immediately upon posting.
      </p>

      <h2 style={styles.subtitle}>10. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy or our practices, please contact us at:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}><strong>Email:</strong> support@kentechphonerepairs.co.uk</li>
        <li style={styles.listItem}><strong>Phone:</strong> 07944 859580</li>
        <li style={styles.listItem}><strong>Address:</strong> 24-25 New Rd, Gravesend DA11 0AA</li>
      </ul>
      <p>
        <em>Please note: This Privacy Policy is provided for informational purposes only and is not legal advice.</em>
      </p>
    </div>
  );
}

const styles = {
  container: {
    padding: '2rem',
    maxWidth: '800px',
    margin: '0 auto',
    fontFamily: 'SeoulBlack, sans-serif',
    color: '#6c757d',
    lineHeight: 1.6,
  },
  title: {
    textAlign: 'center',
    marginBottom: '1.5rem',
    color: '#007BFF',
  },
  subtitle: {
    marginTop: '2rem',
    marginBottom: '1rem',
    color: '#007BFF',
  },
  list: {
    listStyleType: 'disc',
    paddingLeft: '1.5rem',
  },
  listItem: {
    marginBottom: '1rem',
  },
};

export default PrivacyPolicy;
